<template >
    <div class="row">
            <div class="col s12" >
                <fieldset>
                    <legend>{{this.legend}}</legend>
                    <br />
                    <center>
                            <pre v-html="this.title">
                            </pre>
                        </center><br />
                    <div class="row col s6"  v-for="(item,index) in this.avaliacao" :key="index">
                            <label class="active" :for="'input'+item.id">
                                {{item.nome}}<br/>({{item.nota_min}} até {{item.nota_max}})
                            </label>

                            <select v-model="item.nota" :id="'select'+item.id" class="browser-default" @change="sumNota()">
                               <option v-for="(o,i) in getOptions(item)" :key="i" :value="o">
                                   {{o}}
                               </option>
                            </select>


                    </div>
                    <div class="row">
                        <div class="col s6">
                            <span style="font-size:24px" >Nota:{{total}}</span>
                        </div>
                        <div class="col s6">
                            <button
                            id="avaliar"
                            type="button"
                            class="btn"
                            @click="submit($event)"
                            name="btnAvaliar"
                        >
                            Avaliar
                        </button>
                        </div>

                    </div>

                </fieldset>


            </div>

        </div>
</template>
<style>
    .pre-formatted {
        white-space: pre;
    }
</style>
<script>

    import BaseCard from './BaseCard.vue';
    import {calcularNota} from '../utils';
    import { mapState, mapMutations } from 'vuex';
    export default {
        name:'AvaliacaoNota',
        data(){
            return {
                detalheText:"Mostrar Detalhes",
                total:0,
                options:[],
                selectedItemId:''

            };
        },
        props:[
            'legend',
            'title',
            'avaliacao',
        ],
        components:{
            BaseCard,
        },

        computed:{
            ...mapState(['project']),
            avaliacaoComputed:{
                get(){
                    if(this.$props.avaliacao){
                        return this.$props.avaliacao;
                    }else
                        return undefined;
                }
            }

        },
        watch:{
            avaliacaoComputed(newValue,oldValue){
                if(newValue)
                    this.sumNota();
            }
        },
        methods:{
            calcularNota,
            ...mapMutations(['setProject']),

            getOptions(item){

                if(this.$props.avaliacao){
                    let aux=[];
                    var i=0;
                    for(;Number(i).toFixed(1)<=Number(item.nota_max);i=Number(i)+Number(item.nota_var)){
                        aux.push(i.toFixed(1));
                    }

                    return aux;


                }
            },
            getNota(id){
                return this.avaliacao.find(e=>e.id == id);
            },
            sumNota(){
               this.$set(this,'total',0);
                if(this.avaliacaoComputed.length){
                    let total=0;
                    total=this.avaliacaoComputed.map(e=>Number(e.nota)).reduce((acc,e)=>Number(acc)+Number(e));
                    this.$set(this,'total',total.toFixed(2));

                }
            },
            submit(e){
                e.preventDefault();
                this.$emit('submit',this.avaliacaoComputed);
            },
            verifyIntervalo(nota,item){
                let isValid=false;
                item.nota_min=Number(item.nota_min);
                item.nota_max=Number(item.nota_max);
                item.nota_var=Number(item.nota_var);
                let i=0;
                for(i=item.nota_min;i<=item.nota_max && !isValid;i=i+item.nota_var){
                    if((nota.toFixed(2) == i.toFixed(2)) || (nota.toFixed(2) == (i+item.nota_var).toFixed(2)))
                        isValid=true;
                }

                return isValid;
            },
            verifyNota(item){
                let nota=0;
                if(isNaN(item.nota)){
                    return false;
                }
                else{
                    if(nota=Number(item.nota)){
                        if(!(Number(item.nota_min)<= nota && nota <=Number(item.nota_max))){
                            let index=this.avaliacaoComputed.findIndex(e=>e.id == item.id);
                            let obj=this.avaliacaoComputed[index];
                            this.$set(obj,'nota',0);
                            showMsg('Por favor, digite uma nota dentro do intervalo');
                        }else{
                            if(!this.verifyIntervalo(nota,item)){
                                let index=this.avaliacaoComputed.findIndex(e=>e.id == item.id);
                                let obj=this.avaliacaoComputed[index];
                                this.$set(obj,'nota',0);
                                showMsg('Por favor, digite uma nota dentro do intervalo');
                            }

                        }
                    }
                    this.sumNota();
                }



            }


        },

        mounted(){
            if(global.$)
                $(".materialize-select").formSelect();
            this.sumNota();
        }
    }
</script>
